export function getPathname() {
  const pathParts = window.location.pathname.split("/");
  const pathname = pathParts[pathParts.length - 1];
  return pathname;
}
